import { IconArrowRightDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useOutcomePagesBucket } from '../../../experiments/pen-3596_v1'

export const ContentListHeading = () => {
  const { t } = useTranslation('@mc/next')
  const { bucket, isVariant } = useOutcomePagesBucket()

  if (!isVariant) return null

  return (
    <div className='container mc-mt-12 mc-mb-4'>
      <h3 className='mc-text-h5 d-inline-flex align-items-center'>
        {t(`outcomePage.contentList.heading.${bucket}`)}
        <IconArrowRightDefault
          className='mc-ml-2 mc-text-color--primary'
          style={{ transform: 'rotate(45deg)' }}
          size='lg'
        />
      </h3>
    </div>
  )
}
